import basicChartMixin from './chart-basic.mixin';

export default {
  name: 'ChartBarMixin',
  mixins: [basicChartMixin],
  methods: {
    getBarChartOptions() {
      return this.getBasicChartOptions('bar');
    },
  },
};
